export default __webpack_public_path__ + "static/media/Event_sponsor.96a41b67.png";